import * as mutationTypes from './mutationTypes';
import { getErrorMessage } from '../../helpers/functions';
import enums from './enums';

const actions = {
  async fetchTenDlcEnums({ commit, state, getters }, { apiKey }) {
    if (state.fetchingAllTenDlcEnums || getters.tenDlcEnumsAreLoaded) return;
    commit(mutationTypes.FETCH_ALL_TENDLC_ENUMS);
    try {
      commit(mutationTypes.DONE_FETCHING_ALL_TENDLC_ENUMS, { apiKey, enums });
    } catch (e) {
      commit(mutationTypes.ERROR_FETCHING_ALL_TENDLC_ENUMS, { error: getErrorMessage(e) });
    }
  },
};
export default actions;
